import React from 'react'

import frankLogoSolidWhite from '$assets/icons/frankLogoSolidWhite.svg'
import LocaleSelector from '$src/i18n/components/LocaleSelector'
import {resolveCss} from '$util'

import css from './index.css'

export default props => {
  const classes = resolveCss(css)
  return (
    <div {...classes('container')}>
      <img {...classes('logo')} src={frankLogoSolidWhite} alt="logo" />
      <LocaleSelector />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/common/components/Header/index.js